<template>
  <div class="appPage" v-loading="loading">
    <div class="app-view">
      <img src="../../../static/image/app.png" width="100%" height="auto" alt />
      <div class="menuBg" v-if="appView.widgetMap.lbt&&appView.widgetMap.lbt.length>0">
        <div style="padding: 10px;">
          <el-carousel height="150px">
            <el-carousel-item v-for="(item,index) in appView.widgetMap.lbt" :key="index">
              <!-- <a :href="item.url"> -->
              <img :src="item.img" width="100%" height="100%" alt />
              <!-- </a> -->
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="toolbar" v-if="appView.widgetMap.twdh&&appView.widgetMap.twdh.length>0">
        <div
          class="toolbar-item"
          :style="'width:'+25+'%'"
          v-for="(item,index) in appView.widgetMap.twdh"
          :key="index"
        >
          <img :src="item.img" width="60px" height="60px" style="border-radius:30px;" alt />
          <div class="toolbar-item-text">{{item.title}}</div>
        </div>
      </div>
      <div class="operation" v-if="appView.widgetMap.spkc&&appView.widgetMap.spkc.length>0">
        <div class="operation-text">热门课程</div>
        <div class="operation-list">
          <!-- <a :href="item.url" v-for="(item,index) in appView.widgetMap.spkc" :key="index"> -->
          <img
            :src="item.img"
            width="170"
            height="100px"
            alt
            v-for="(item,index) in appView.widgetMap.spkc"
            :key="index"
          />
          <!-- </a> -->
        </div>
      </div>
    </div>
    <div class="app-edit">
      <el-button type="primary" @click="$router.push({path:'/appEdit'})">编辑APP首页</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      appView: {
        widgetMap: {
          spkc: [],
          twdh: [],
          lbt: []
        }
      }
    };
  },
  created() {},
  methods: {
    getPageWidgetRelationList() {
      this.loading = true;
      this.api.pageWidgetRelation
        .getPageWidgetRelationList({ pageType: 1 })
        .then(result => {
          this.loading = false;
          if (result.success) {
            this.appView = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {},
  computed: {},
  mounted() {
    this.getPageWidgetRelationList();
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.appPage {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  .app-view {
    width: 375px;
    .operation {
      padding: 10px;
      .operation-text {
        font-size: 18px;
        color: #333;
        margin-bottom: 10px;
        font-weight: bold;
      }
      .operation-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        img {
          margin-bottom: 15px;
          border-radius: 10px;
        }
      }
    }
    .toolbar {
      display: flex;
      flex-wrap: wrap;
      .toolbar-item {
        padding: 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .toolbar-item-text {
          font-size: 14px;
          margin-top: 6px;
        }
      }
    }
    .menuBg {
      width: 100%;
      margin-top: -6px;
      /*background-color: #266ef6;*/
      background: -webkit-linear-gradient(#266ef6, #f1f5f8);
      /* Safari 5.1-6.0 */
      background: -o-linear-gradient(#266ef6, #f1f5f8);
      /* Opera 11.1-12.0 */
      background: -moz-linear-gradient(#266ef6, #f1f5f8);
      /* Firefox 3.6-15 */
      background: linear-gradient(#266ef6, #f1f5f8);
      /* 标准语法*/
      img {
        border-radius: 6px;
      }
    }
  }
  .app-edit {
    margin-left: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/appPage/appPage.vue